class ChartDefinition {
    chartType: KnockoutObservable<ChartType>;
    colorTheme: KnockoutObservable<number>;
    colorPerSerie: KnockoutObservable<boolean>;
    labelVisibility: KnockoutObservable<boolean>;
    labelAlign: KnockoutObservable<FontAlignmentEnum>;
    labelPosition: KnockoutObservable<string>;
    labelShowValue: KnockoutObservable<boolean>;
    labelShowElement: KnockoutObservable<boolean>;
    labelShowMetricName: KnockoutObservable<boolean>;
    labelShowGroupingElement: KnockoutObservable<boolean>;
    legendPosition: KnockoutObservable<LegendPositionEnum>;
    bubbleMaxSize: KnockoutObservable<number>;
    bubbleMinSize: KnockoutObservable<number>;
    labelApplyBackgroundColor: KnockoutObservable<boolean>;
    labelFontColor: KnockoutObservable<string>;
    labelOverlapping: KnockoutObservable<any>;
    labelRotationAngle: KnockoutObservable<number>;
    labelFormat: KnockoutObservable<LabelFormatEnum>;
    labelDecimalPlaces: KnockoutObservable<number>;
    showMetricsYAxis: KnockoutObservable<boolean>;
    axisLabelDisplayMode: KnockoutObservable<AxisLabelDisplayModeEnum>;
    axisLabelAngle: KnockoutObservable<number>;
    axisValueMargin: KnockoutObservable<number>;
    labelConnector: KnockoutObservable<boolean>;

    getaxisLabelDisplayMode() {
        switch (this.axisLabelDisplayMode()) {
            case AxisLabelDisplayModeEnum.Rotate:
                return "rotate";
            case AxisLabelDisplayModeEnum.Stagger:
                return "stagger";
            case AxisLabelDisplayModeEnum.Standard:
                return "standard";
        }
    }

    // bubbleSizeMetric: KnockoutObservable<string>;
    // bubbleXMetric: KnockoutObservable<string>;

    constructor(data: any) {
        this.chartType = ko.observable(data.chartType);
        this.labelPosition = ko.observable(data.labelPosition);
        this.axisLabelDisplayMode = ko.observable(data.axisLabelDisplayMode);
        this.axisLabelAngle = ko.observable(data.axisLabelAngle);
        this.axisValueMargin = ko.observable(data.axisValueMargin);
        this.labelConnector = ko.observable(data.labelConnector);

        this.colorTheme = ko.observable(data.colorTheme ?? 59);
        this.colorPerSerie = ko.observable(data.colorPerSerie === undefined ? false : data.colorPerSerie);
        this.showMetricsYAxis = ko.observable(data.showMetricsYAxis === undefined ? false : data.showMetricsYAxis);
        this.labelVisibility = ko.observable(data.labelVisibility ?? true);
        this.labelAlign = ko.observable(data.labelAlign ? (typeof data.labelAlign === "string" ? parseInt(data.labelAlign) : data.labelAlign) : FontAlignmentEnum.Center);
        this.labelShowValue = ko.observable(data.labelShowValue === undefined ? true : data.labelShowValue);
        this.labelShowElement = ko.observable(data.labelShowElement === undefined ? false : data.labelShowElement);
        this.labelShowMetricName = ko.observable(data.labelShowMetricName === undefined ? false : data.labelShowMetricName);
        this.labelShowGroupingElement = ko.observable(data.labelShowGroupingElement === undefined ? true : data.labelShowGroupingElement);
        this.legendPosition = ko.observable(data.legendPosition ?? LegendPositionEnum.Bottom);
        this.labelApplyBackgroundColor = ko.observable(data.labelApplyBackgroundColor ?? true);
        this.labelFontColor = ko.observable(data.labelFontColor ?? null);
        this.labelOverlapping = ko.observable(data.labelOverlapping ?? "hide");
        this.labelRotationAngle = ko.observable(data.labelRotationAngle ?? 0);
        this.labelFormat = ko.observable(data.labelFormat ?? LabelFormatEnum.Automatic);
        this.labelDecimalPlaces = ko.observable(data.labelDecimalPlaces ?? 0);
        this.bubbleMaxSize = ko.observable(data.bubbleMaxSize ?? 50);
        this.bubbleMinSize = ko.observable(data.bubbleMinSize ?? 5);
        //this.bubbleSizeMetric = ko.observable(data.bubbleSizeMetric ?? "");
        //this.bubbleXMetric = ko.observable(data.bubbleXMetric ?? "");
    }
}